/*
 * @Author: Yolo
 * @Date: 2024-07-09 15:48:52
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-19 09:39:08
 * @Desc ais 图层工具类
 */
import { toRaw } from 'vue'
import L from 'leaflet'
import { merge } from 'lodash-unified'
import type { CanvasShip } from '@map-sdk/sdk/model/CanvasShip'
import type { MyMap } from '@map-sdk/sdk'

interface AisManageOptions {
  aisLayerUrl: string
  aisLayerOptions: L.TileLayerOptions
  loadAisShipUrl: string
  aisLayerMinZoom: number
  aisLayerMaxZoom: number
  showAisShipZoom: number
  loadAisShip?: (params: L.LatLngBounds, done: (shipList: any) => void) => void
}

class AisManager {
  map: any
  options: AisManageOptions = {
    aisLayerUrl: 'https://api.xplusship.com/aismap/ac1/{x}/{y}/{z}.png',
    aisLayerOptions: { minZoom: 0, maxZoom: 9, attribution: '' },
    loadAisShipUrl: '',
    aisLayerMinZoom: 3,
    aisLayerMaxZoom: 18,
    showAisShipZoom: 9,
  }
  aisLayer!: L.TileLayer
  constructor(map: MyMap, options: Partial<AisManageOptions> = {}) {
    this.map = toRaw<MyMap>(map)
    this.options = merge(this.options, options)
  }

  private _done(shipList: CanvasShip[]) {
    if (shipList.length) {
      this.map.shipsService.addSpecialShips(toRaw(shipList))
    }
  }

  private async _addAisLayer(zoom: number) {
    if (
      zoom > this.options.aisLayerMinZoom &&
      zoom < this.options.aisLayerMaxZoom
    ) {
      if (zoom < this.options.showAisShipZoom) {
        this.map.shipsService.deleteSpecialShips(true)
        if (!this.aisLayer) {
          this.aisLayer = L.tileLayer(
            this.options.aisLayerUrl,
            this.options.aisLayerOptions
          )
        }
        this.map.addLayer(this.aisLayer)
      } else {
        this.map.removeLayer(this.aisLayer)
        this.options.loadAisShip &&
          this.options.loadAisShip(this.map.getBounds(), this._done)
      }
    } else {
      this.hide(false)
    }
  }
  private _Event = {
    zoomend: (e: any) => this._addAisLayer(e.target._zoom),
  }

  show() {
    if (!this.map) return
    this._addAisLayer(this.map.getZoom())
    this.map.on('zoomend', this._Event.zoomend)
  }

  hide(isRemoveOn = true) {
    if (this.aisLayer) {
      this.map.removeLayer(this.aisLayer)
      if (isRemoveOn) {
        this.map.off('zoomend', this._Event.zoomend)
      }
      this.map.shipsService.deleteSpecialShips(true)
    }
  }
}

export { AisManager, type AisManageOptions }
